export default __webpack_public_path__ + "static/Supreme-Regular-9ef1f7a358069a009641a02ca2ecac2c.woff2";